import { useTranslation } from 'react-i18next'

import { useTheme } from 'styled-components'

import { InputWithLabel } from '@reveni-io/reveni-ui'

import { conceptAmountErrors } from '@/returns/constants'

import { getAmountAdornment, getFormattedAmount } from '../helpers'
import * as Styles from './styles'

const ConceptAmountInput = ({ label, value, currency, isNegative, maxAmount, error, disabled, onChange }) => {
  const { t, i18n } = useTranslation()
  const theme = useTheme()

  const handleChange = event => {
    onChange(event.target.value)
  }

  const getHelperText = () => {
    const formattedMaxAmount = getFormattedAmount({ amount: maxAmount, currency, language: i18n.language })

    if (error === conceptAmountErrors.invalid) return t('Introduce un importe válido')
    if (error === conceptAmountErrors.exceeded) return t('No puede superar {{amount}}', { amount: formattedMaxAmount })

    return t('de {{amount}}', { amount: formattedMaxAmount })
  }

  return (
    <Styles.Container hasError={Boolean(error)}>
      <InputWithLabel
        fullWidth
        type="number"
        value={value}
        onChange={handleChange}
        disabled={disabled}
        backgroundColor={theme.colors.white}
        startAdornment={getAmountAdornment({ currency, isNegative })}
        helperText={getHelperText()}
        role="spinbutton"
        inputProps={{ min: 0, step: '0.01', 'aria-label': label }}
      />
    </Styles.Container>
  )
}

export default ConceptAmountInput
